import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../hooks/useAuth';

interface ProtectedRouteProps {
  children: React.ReactNode;
}

const ProtectedRoute: React.FC<ProtectedRouteProps> = ({ children }) => {
  const { isAuthenticated, isLoadingProfile, profileError } = useAuth();
  const location = useLocation();

  // If there's a profile error (like 401), redirect immediately
  if (profileError) {
    const error = profileError as any;
    if (error?.response?.status === 401) {
    
      return <Navigate to="/login" state={{ from: location }} replace />;
    }
  }

  // Show loading while checking authentication
  // if (isLoadingProfile) {
    
  //   return (
  //     <div className="min-h-screen flex items-center justify-center">
  //       <div className="text-center">
  //         <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-primary mx-auto mb-4"></div>
  //         <p className="text-gray-600">Loading...</p>
  //       </div>
  //     </div>
  //   );
  // }

  // Redirect to login if not authenticated
  if (!isAuthenticated) {

    return <Navigate to="/login" state={{ from: location }} replace />;
  }


  return <>{children}</>;
};

export default ProtectedRoute;
